import React, { FC, useState } from 'react';
import ColorButton from './UI/ColorButton';
import { useAppDispatch, useAppSelector } from '../hooks/redux-hooks';
import { fetchChangePassword, deleteServerMessage } from '../store/slices/carSlice';

interface ChangePasswordProps {
    onClose?: () => void;
}

const ChangePassword: FC<ChangePasswordProps> = ({ onClose }) => {
    const dispatch = useAppDispatch();

    const userId = useAppSelector((state) => state.data.data?.user?.id);

    const [oldPassword, setOldPassword] = useState('');
    const [visibleOldPassword, setVisibleOldPassword] = useState(false);
    const [newPassword, setNewPassword] = useState('');
    const [visibleNewPassword, setVisibleNewPassword] = useState(false);
    const [repeatNewPassword, setRepeatNewPassword] = useState('');
    const [visibleRepeatNewPassword, setVisibleRepeatNewPassword] = useState(false);

    const error = useAppSelector((state) => state.data.error);
    const status = useAppSelector((state) => state.data.status);
    const [localError, setLocalError] = useState('');

    const handleChangePassword = async () => {
        if (!oldPassword || !newPassword || !repeatNewPassword) {
            setLocalError('Заполните все поля!');
            return;
        }

        if (newPassword !== repeatNewPassword) {
            setLocalError('Пароли не совпадают!');
            return;
        }

        try {
            // Ждём успешного ответа
            await dispatch(
                fetchChangePassword({
                    id: userId,
                    old_pass: oldPassword,
                    new_pass: newPassword,
                })
            ).unwrap();

            // ✅ Успех: сброс, закрытие, уведомление
            setOldPassword('');
            setNewPassword('');
            setRepeatNewPassword('');
            setLocalError('');
            dispatch(deleteServerMessage()); // очистить server_message, если нужно

            // Можно использовать alert или лучше — показать в интерфейсе
            alert('Пароль успешно изменён!');

            // Закрываем модальное окно
            if (onClose) {
                onClose();
            }
        } catch (err) {
            // Ошибка уже будет в state.data.error, но можно логировать
            console.error('Ошибка смены пароля:', err);
            // Оставляем error в интерфейсе
        }
    };

    return (
        <div className="change_password_window_container">
            <span style={{ fontSize: '25px', color: 'white' }}>Смена пароля</span>

            <div className="input-container_">
                <input
                    className="change_input"
                    type={visibleOldPassword ? 'text' : 'password'}
                    value={oldPassword}
                    onChange={(e) => setOldPassword(e.target.value)}
                    onFocus={() => setVisibleOldPassword(true)}
                    onBlur={() => setVisibleOldPassword(false)}
                    placeholder=" "
                />
                <label className="placeholder_" htmlFor="old-pass">
                    Введите старый пароль
                </label>
                {(visibleOldPassword || oldPassword) && <label className="background_old">0</label>}
            </div>

            <div className="input-container_">
                <input
                    className="change_input"
                    type={visibleNewPassword ? 'text' : 'password'}
                    value={newPassword}
                    onChange={(e) => setNewPassword(e.target.value)}
                    onFocus={() => setVisibleNewPassword(true)}
                    onBlur={() => setVisibleNewPassword(false)}
                    placeholder=" "
                />
                <label className="placeholder_" htmlFor="new-pass">
                    Введите новый пароль
                </label>
                {(visibleNewPassword || newPassword) && <label className="background_new">0</label>}
            </div>

            <div className="input-container_">
                <input
                    className="change_input"
                    type={visibleRepeatNewPassword ? 'text' : 'password'}
                    value={repeatNewPassword}
                    onChange={(e) => setRepeatNewPassword(e.target.value)}
                    onFocus={() => setVisibleRepeatNewPassword(true)}
                    onBlur={() => setVisibleRepeatNewPassword(false)}
                    placeholder=" "
                />
                <label className="placeholder_" htmlFor="repeat-pass">
                    Повторите новый пароль
                </label>
                {(visibleRepeatNewPassword || repeatNewPassword) && <label className="background_new_">0</label>}
            </div>

            {error && <span className="error">{error}</span>}
            {localError && <span className="error">{localError}</span>}

            <ColorButton
                onClick={handleChangePassword}
                disabled={status === 'loading'}
                className="save"
            >
                {status === 'loading' ? 'Сохранение...' : 'Сохранить'}
            </ColorButton>
        </div>
    );
};

export default ChangePassword;